import { useMemo } from 'react';

import { getCurrentSignupSubscriptionType } from '@farmersdog/lead-browser-storage';

import { useGetLead } from '../../../../graphql/queries';

import { useCouponData } from './useCouponData';

import type { AttributesContextualInfo } from '../types';

export function useAttributesContextualInfo(): AttributesContextualInfo {
  const lead = useGetLead().data?.lead;
  const couponData = useCouponData();
  const currentSignupSubscriptionType = getCurrentSignupSubscriptionType();

  return useMemo(
    () =>
      ({
        lead,
        couponData,
        currentSignupSubscriptionType,
      }) as const,
    [lead, couponData, currentSignupSubscriptionType]
  );
}
